const SESSION_FALLBACK = new Map();
const HIDDEN_VALUE = "hidden";

export const cspPromptPreferenceKey = ({ tenantId, objectId, slug }) => {
  if (![tenantId, objectId, slug].every((value) => typeof value === "string" && value.length > 0)) return null;
  return `ss365:csp-prompt:v1:${JSON.stringify([tenantId, objectId, slug])}`;
};

export const readCspPromptPreference = (storage, key) => {
  if (!key) return { hidden: false, persistence: "none" };
  if (SESSION_FALLBACK.has(key)) return { hidden: SESSION_FALLBACK.get(key), persistence: "session" };
  if (!storage) return { hidden: SESSION_FALLBACK.get(key) === true, persistence: "session" };
  try {
    return { hidden: storage?.getItem(key) === HIDDEN_VALUE, persistence: "persistent" };
  } catch {
    return { hidden: SESSION_FALLBACK.get(key) === true, persistence: "session" };
  }
};

export const writeCspPromptPreference = (storage, key, hidden) => {
  if (!key) return { hidden: false, persistence: "none" };
  if (!storage) {
    SESSION_FALLBACK.set(key, !!hidden);
    return { hidden, persistence: "session" };
  }
  try {
    if (hidden) storage?.setItem(key, HIDDEN_VALUE);
    else storage?.removeItem(key);
    SESSION_FALLBACK.delete(key);
    return { hidden, persistence: "persistent" };
  } catch {
    SESSION_FALLBACK.set(key, !!hidden);
    return { hidden, persistence: "session" };
  }
};
